// import Vue from "vue";

// initial state
const state = {
  legalVisible: false,
  debugLog: "",
};

// getters
const getters = {
  getLegalVisible(state) {
    return state.legalVisible;
  },
};

// actions
const actions = {
  setLegalVisible({ commit, state }, value) {
    commit("SET_LEGAL_VISIBLE", { legalVisible: value });
  },

  setDebugLog({ commit, state }, value) {
    commit("SET_DEBUG_LOG", { debugLog: value });
  },
};

// mutations
const mutations = {
  SET_LEGAL_VISIBLE(state, payload) {
    state.legalVisible = payload.legalVisible;
  },

  SET_DEBUG_LOG(state, payload) {
    state.debugLog = payload.debugLog;
    // document.querySelector('#debugLog').innerText = payload.debugLog;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
